import styled from "styled-components";


export const Container = styled.div`
   
`;

export const Message = styled.div`
    color: ${props => props.state ? "green": "red"};
`;